/* global Office, document */
import LogHelper from "./logHelper";
import QuickBooks from './quickBooks';


const logHelper = new LogHelper();
const quickBooks = new QuickBooks();

export function loadSettings() {
  const filesystemSelect = document.getElementById('filesystemSelect');
  const qboUploadCheckbox = document.getElementById('qboUploadCheckbox');
  // const qboInputsDiv = document.getElementById('qboInputs');
  // const qboClientIdInput = document.getElementById('qboClientId');
  // const qboClientSecretInput = document.getElementById('qboClientSecret');
  // const qboCompanyIdInput = document.getElementById('qboCompanyId');

  const savedFilesystem = Office.context.document.settings.get('filesystemOption') || 'Downloads';
  filesystemSelect.value = savedFilesystem;

  const savedQboUpload = Office.context.document.settings.get('qboUploadEnabled') === 'true';
  qboUploadCheckbox.checked = savedQboUpload;
  // qboInputsDiv.style.display = savedQboUpload ? 'block' : 'none';
  if (savedQboUpload) {
    quickBooks.getUserAndCompanyInfo().then((result) => {
      if (result?.showLoginBtn) {
        document.getElementById('loginQBOBtn').classList.remove('hide');
      }
    });
    // qboClientIdInput.value = Office.context.document.settings.get('qboClientId') || '';
    // qboClientSecretInput.value = Office.context.document.settings.get('qboClientSecret') || '';
    // qboCompanyIdInput.value = Office.context.document.settings.get('qboCompanyId') || '';
  }
}

export async function saveSetting(key, value) {
  try {
    Office.context.document.settings.set(key, value);
    await new Promise((resolve, reject) => {
      Office.context.document.settings.saveAsync((result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          // console.log(`Setting "${key}" saved successfully.`);
          resolve();
        } else {
          console.error(`Failed to save setting "${key}":`, result.error);
          reject(result.error);
        }
      });
    });
  } catch (err) {
    console.error("Unexpected error saving setting:", err);
  }
}